var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ehc-form',{staticClass:"mt-7",attrs:{"meta":_vm.meta},on:{"submit":_vm.update},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }